import type { NewsSignal } from '../../domain/signal';
import { NewsCategory, NewsSignalSubType } from '../../domain/signal';

export const COMPANY_CHALLENGES = 'Company challenges';

export type NewsSignalEventsTagsMapType = Record<NewsCategory, string[]>;

export const newsSignalEventsTagsMap: NewsSignalEventsTagsMapType = {
  [NewsCategory.Hires]: [NewsSignalSubType.Leadership, 'New executive'],
  [NewsCategory.Promotes]: [NewsSignalSubType.Leadership, 'New executive'],
  [NewsCategory.Leaves]: [NewsSignalSubType.Leadership],
  [NewsCategory.Retires]: [NewsSignalSubType.Leadership],
  [NewsCategory.OpensNewLocation]: [NewsSignalSubType.Growth, 'New office'],
  [NewsCategory.ExpandsOfficesIn]: [NewsSignalSubType.Growth],
  [NewsCategory.ExpandsOfficesTo]: [NewsSignalSubType.Growth],
  [NewsCategory.ExpandsFacilities]: [NewsSignalSubType.Growth, 'New facilities'],
  [NewsCategory.SignsNewClient]: [NewsSignalSubType.Growth, 'New client'],
  [NewsCategory.IncreasesHeadcountBy]: [NewsSignalSubType.Growth, 'Hiring'],
  [NewsCategory.Acquires]: [NewsSignalSubType.Strategy, 'Acquire'],
  [NewsCategory.MergesWith]: [NewsSignalSubType.Strategy],
  [NewsCategory.Launches]: [NewsSignalSubType.Strategy, 'New offering'],
  [NewsCategory.IntegratesWith]: [NewsSignalSubType.Strategy],
  [NewsCategory.IsDeveloping]: [NewsSignalSubType.Strategy, 'Partnership'],
  [NewsCategory.PartnersWith]: [NewsSignalSubType.Strategy],
  [NewsCategory.SellsAssetsTo]: [NewsSignalSubType.Strategy],
  [NewsCategory.IdentifiedAsCompetitorOf]: [NewsSignalSubType.Strategy],
  [NewsCategory.ReceivesFinancing]: [NewsSignalSubType.Investment, 'Funding'],
  [NewsCategory.InvestsInto]: [NewsSignalSubType.Investment],
  [NewsCategory.InvestsIntoAssets]: [NewsSignalSubType.Investment],
  [NewsCategory.GoesPublic]: [NewsSignalSubType.Investment, 'IPO'],
  [NewsCategory.ClosesOffices]: [COMPANY_CHALLENGES, 'Closes office'],
  [NewsCategory.DecreasesHeadcountBy]: [COMPANY_CHALLENGES, 'Layoff'],
  [NewsCategory.FilesSuitAgainst]: [COMPANY_CHALLENGES],
  [NewsCategory.HasIssuesWith]: [COMPANY_CHALLENGES],
};

export const getNewsSignalEventTags = (signal: NewsSignal): string[] => {
  const { categories } = signal;
  return categories
    .map((category) => (newsSignalEventsTagsMap[category] ? newsSignalEventsTagsMap[category] : []))
    .flat();
};
